import api from "PFCore/api";
import { Id, Notification, PaginatedCollection } from "PFTypes";

export type FetchNotificationsPayload = {
  categories?: string[];
  excludedCategories?: string[];
  roleId?: Id;
  engagementId?: Id;
  perPage?: number;
  page?: number;
  templateKey?: string;
  read?: boolean;
  important?: boolean;
};

export type FetchNotificationsResponse = PaginatedCollection<
  Notification[],
  { totalUnread: number; availableCategories: string[] }
>;

export const fetchNotifications = ({
  categories,
  page = 1,
  perPage = 0,
  read = undefined,
  important = undefined,
  templateKey = undefined,
  excludedCategories,
  roleId,
  engagementId
}: FetchNotificationsPayload) =>
  api<FetchNotificationsResponse>({
    url: "notifications",
    params: {
      categories,
      excludedCategories,
      roleId,
      engagementId,
      page,
      perPage,
      ...(read !== undefined ? { read } : {}),
      ...(important !== undefined ? { important } : {}),
      ...(templateKey ? { templateKey } : {})
    }
  });
